// Text the admin typed passes the save path's XSS filter (backend/middlewares/xss.js),
// which stores ' " & < > as HTML entities — back to the characters, to show as typed.
// React escapes it again when rendering, so this is display text, never markup.
export const plain = (value) => String(value ?? '')
    .replace(/&#x27;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
